module.exports = __webpack_public_path__ + "static/media/home_avatar7.417b3f31.png";